export type User = {
  firstName: string,
  middleName: string,
  lastName: string,
  email: string,
}

export enum UserGroup {
  Admin = 'INCTVAdmin',
}
